import { render } from "./Result.vue?vue&type=template&id=d98b577e&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=d98b577e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98b577e"]])

export default __exports__